var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentDashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26.6573V37.7645C0 46.3526 6.96201 53.3146 15.5501 53.3146H26.6573H37.7645C46.3526 53.3146 53.3146 46.3526 53.3146 37.7645V26.6573V15.5501C53.3146 6.96201 46.3526 0 37.7645 0H26.6573H15.5501C6.96201 0 0 6.96201 0 15.5501V26.6573Z",
    fill: "#4AD991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9813 36.3325H37.7147C38.4781 36.3325 39.0969 36.9513 39.0969 37.7147C39.0969 38.4781 38.4781 39.0969 37.7147 39.0969H15.599C14.8356 39.0969 14.2168 38.4781 14.2168 37.7147V15.599C14.2168 14.8356 14.8356 14.2168 15.599 14.2168C16.3624 14.2168 16.9813 14.8356 16.9813 15.599V36.3325Z",
    fill: "#646464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.1367 30.3668C21.6146 30.9238 20.7399 30.952 20.183 30.4299C19.626 29.9077 19.5978 29.033 20.1199 28.4761L25.3033 22.9472C25.8082 22.4086 26.6473 22.3619 27.2089 22.8411L31.3 26.3321L36.6302 19.5805C37.1032 18.9813 37.9724 18.8791 38.5716 19.3521C39.1707 19.8251 39.273 20.6943 38.8 21.2935L32.5799 29.1722C32.0941 29.7876 31.1942 29.8761 30.5978 29.3671L26.4179 25.8003L22.1367 30.3668Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDashIcon);
export default __webpack_public_path__ + "static/media/payment-dash-icon.8e97b0f4cc4d1ea41093bf4ce5779298.svg";
export { ForwardRef as ReactComponent };